module.exports = __webpack_public_path__ + "img/Argon Dashboard PRO@3x.2df784db.png";